import { defineStore } from 'pinia'
import { i18n } from '../utils/i18n'
import { useStore } from './main'
import { useToastStore } from './toast'
import { useUserStore } from './user'

interface State {
    isSideMenuDisplayed: boolean
}

export const useMenuStore = defineStore('menu', {
    state: (): State => ({
        isSideMenuDisplayed: false,
    }),

    actions: {
        toggleSideMenuDisplay(): void {
            const mainStore = useStore()

            this.isSideMenuDisplayed = !this.isSideMenuDisplayed

            if (!mainStore.readonly) {
                this.isSideMenuDisplayed
                    ? mainStore.disableCapture()
                    : mainStore.enableCapture()
            }

            mainStore.updateLockState()

            this.showMenuShortcutToastWhenEligible()
        },

        showMenuShortcutToastWhenEligible(): void {
            const userStore = useUserStore()
            const toastStore = useToastStore()

            if (this.isSideMenuDisplayed) {
                return
            }

            if (
                !userStore.user.player_preferences
                    .is_cursor_captured_mode_enabled
            ) {
                return
            }

            window.setTimeout(() => {
                const userStore = useUserStore()

                const message = i18n.t('common.sentence.menuShortcutReminder', [
                    userStore.user.player_preferences.side_menu_shortcut[0].toUpperCase(),
                    userStore.user.player_preferences.side_menu_shortcut[1].toUpperCase(),
                ])

                toastStore.toastInfo(
                    message,
                    null,
                    5000,
                    // Not closable because not accessible in server mode
                    false
                )
            }, 1000)
        },
    },
})
